import React from 'react';

import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';
import { sanitizeData } from '../../core/components/FormComponent';
import { FormHandles } from '@unform/core';
import { useParams } from 'react-router-dom';
import sendMail from './Modules/SendSaleMail';
import { useConfiguration } from '../../../../hooks/Configuration';
import SaleStats from './Modules/SaleStats';
import ContactModule from './Modules/ContactModule';
import CreateMedicSubscription from './Modules/CreateMedicSubscription';
import { FaMoneyCheck } from 'react-icons/fa';
import { useAuth } from '../../../../hooks/Auth';
import { FinanceReportModule } from './Modules/CheckFinance';
import visualizarBoleto from './Modules/VisualizarBoleto';
import sendPayment from './Modules/SendPayment';
import contact from './Modules/ContactModule';
import sendAllPayments from './Modules/SendAllPayments';
import ReprocessInvoices from './Modules/ReprocessInvoices';
import DuplicatePayment from './Modules/DuplicatePayment';

import DuplicatePaymentReference from './Modules/DuplicatePaymentReference';


import SendInvoiceMail from './Modules/SendInvoiceMail';
import SendInvoiceTestMail from './Modules/SendInvoiceTestMail';

import exportGlobalData from './Modules/ExportData';
interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}

const callback = (string, form: React.RefObject<FormHandles>) => {
  const installments = form?.current?.getFieldValue('installment') || 1;

  const discount =
    sanitizeData.currencyInput(form?.current?.getFieldValue('discount')) || 0;

  const total =
    sanitizeData.currencyInput(form?.current?.getFieldValue('total')) || 0;

  const installmentValue = parseInt(
    ((total - discount) / installments).toString(),
    10,
  );

  form?.current?.setFieldValue('installment_value', installmentValue);
};

const Sale: React.FC = () => {
  const endpoint = '/sales-invoice';
  const title = 'Faturas';
  const { user } = useAuth();
  const formSchema = {
    client_id: {
      alias: 'client_id',
      model: 'selectApi',
      name: 'client_id',
      label: 'Cliente',
      endpoint,
    },

    payment_date: { model: 'datePicker', type: 'text', name: 'payment_date', label: 'Data de vencimento' },
    installment_number: { model: 'input', type: 'text', name: 'installment_number', label: 'Nº da fatura' },
    invoice_hash: { model: 'input', type: 'text', name: 'invoice_hash', label: 'HASH da Invoice' },
    category: { model: 'input', type: 'text', name: 'category', label: 'Categoria' },
    area: { model: 'input', type: 'text', name: 'area', label: 'Área' },
    subarea: { model: 'input', type: 'text', name: 'subarea', label: 'Subárea' },
    fields: {
      model: 'jsonList',
      type: 'text',
      name: 'fields',
      label: 'Campos',
      list: [
        { label: 'Requisição', name: 'requisicao', type: 'input' },

      ],
    },
    fields_text: { model: 'input', type: 'text', name: 'fields_text', label: 'Campos adicionais' },

    product_id: {
      alias: 'product_id',
      model: 'selectApiDirect',
      name: 'product_id',
      label: 'Produto',

      endpoint: '/products',
    },

    payment_status_id: {
      model: 'selectSimple',
      name: 'payment_status_id',
      label: 'Status de pagamento',
      defaultValue: 'paid',
      options: [
        { label: 'Aguardando', value: 'waiting' },
        { label: 'Pago', value: 'paid' },
        { label: 'Cancelado', value: 'cancelled' },
        { label: 'Aguardando análise do Antifraude', value: 'verificating' },

      ]

    },


    payment_method_id: {
      model: 'selectSimple',
      name: 'payment_method_id',
      label: 'Método de pagamento',

      options: [

        { label: 'Boleto', value: 'boleto_recurring' },
        { label: 'Cartão', value: 'credit_card_recurring' },


      ]

    },
    sale_hash: {
      model: 'input',
      name: 'sale_hash',
      label: 'Hash',
      defaultValue: '',
      callback,
    },
    boleto_url: {
      model: 'input',
      name: 'boleto_url',
      label: 'Hash',
      defaultValue: '',

    },
    total: {
      model: 'currencyInput',
      name: 'total',
      label: 'Total',
      defaultValue: '0',
      callback,
    },
    juros: {
      model: 'currencyInput',
      name: 'juros',
      label: 'Juros',
      defaultValue: '0',
      callback,
    },
    multa: {
      model: 'currencyInput',
      name: 'multa',
      label: 'Multa',
      defaultValue: '0',
      callback,
    },
    discount: {
      model: 'currencyInput',
      name: 'discount',
      label: 'Desconto',
      defaultValue: '0',
      callback,
    },

    installment: {
      model: 'selectSimple',
      name: 'installment',
      label: 'Nº de Parcelas',
      defaultValue: '1',
      options: [
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
        { label: '6', value: 6 },
        { label: '7', value: 7 },
        { label: '8', value: 8 },
        { label: '9', value: 9 },
        { label: '10', value: 10 },
        { label: '11', value: 11 },
        { label: '12', value: 12 },
      ],
      callback,
    },
    installment_value: {
      model: 'currencyInput',
      name: 'installment_value',
      label: 'Valor da parcela',
      defaultValue: '0',
      readOnly: true,
    },
  
    transaction_id: {
      model: 'input',
      name: 'transaction_id',
      label: 'ID da transação',
      defaultValue: '',

    },


    courses: {
      model: 'JsonInput',
      endpoint: `/courses`,
      name: 'courses',
      label: 'Cursos',
    },
  };

  const formValidation: Record<string, ValidationSchema> = {

  };


  const { projectHash, eventHash } = useConfiguration();

  const schema: Record<string, any> = {
    _id: { ref: '_id', column: '_id', label: 'Protocolo', show: false },
    project_id: {
      ref: 'project_id',
      column: 'project_id',
      label: 'Projeto',
      show: false
    },
    event_id: {
      ref: 'event_id',
      column: 'event_id',
      label: 'Evento', show: false

    },
        payment_date: {
      ref: 'payment_date',
      column: 'payment_date',
      label: 'Data de vencimento' 

    },
    client_id: {
      ref: 'client_id',
      column: 'client_id_response',
      includeColumn: 'name',
      label: 'Cliente',
    },
    phone: {
      ref: 'phone',
      column: 'phone',
      label: 'Telefone',
      show: false,
    },
    sale_hash: {
      ref: 'sale_hash',
      column: 'sale_hash',
      label: 'Hash',
      show: false,
    },
    installment_number: {
      ref: 'installment_number',
      column: 'installment_number',
      label: 'Nº da Fatura',
    },
    price: { ref: 'price', column: 'price', label: 'Preço', mask: 'currency' },
     juros: { ref: 'juros', column: 'juros', label: 'Juros', mask: 'currency' },
    multa: { ref: 'multa', column: 'multa', label: 'Multa', mask: 'currency' },
    
installment_value: { ref: 'installment_value', column: 'installment_value', label: 'Valor da Fatura', mask: 'currency' },
   
  total_currency: { ref: 'total_currency', column: 'total_currency', label: 'Total pago', mask: 'currency', sum: ['installment_value', 'multa', 'juros'] },


    payment_status_id: {
      ref: 'payment_status_id',
      column: 'payment_status_id',
      label: 'Status',
    },
    payment_method_id: {
      ref: 'payment_method_id',
      column: 'payment_method_id',

      label: 'Forma de Pagamento',
    },
    invoice_hash: {
      ref: 'invoice_hash',
      column: 'invoice_hash',

      label: 'Código da fatura',
      show: false,
    },
    boleto_url: {
      ref: 'boleto_url',
      column: 'boleto_url',

      label: 'Boleto',
      show: false,
    },
    product: {
      ref: 'product_id',
      column: 'product_id_response',
      includeColumn: 'title',
      label: 'Produto',
    },
    transaction_id: {
      ref: 'transaction_id',
      column: 'transaction_id',
      label: 'ID de conciliação',

    },
    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date',
    },
  };


  const formSchemaPayment = {
    tax: {
      model: 'currencyInput',
      name: 'tax',
      label: 'Taxa Fixa',
      defaultValue: '0',
      callback,
    },
    fees: {
      model: 'currencyInput',
      name: 'fees',
      label: 'Taxas do cliente',
      defaultValue: '0',
      callback,
    },
    administration_tax: {
      model: 'currencyInput',
      name: 'administration_tax',
      label: 'Taxa de transação',
      defaultValue: '0',
      callback,
    },
    transaction_tax: {
      model: 'currencyInput',
      name: 'transaction_tax',
      label: 'Taxa de transação',
      defaultValue: '0',
      callback,
    },
    net_total: {
      model: 'currencyInput',
      name: 'net_total',
      label: 'Total Líquido',
      defaultValue: '0',
      callback,
    },
    total: {
      model: 'currencyInput',
      name: 'total',
      label: 'Total',
      defaultValue: '0',
      callback,
    },
    discount: {
      model: 'currencyInput',
      name: 'discount',
      label: 'Desconto',
      defaultValue: '0',
      callback,
    },
    installment: {
      model: 'selectSimple',
      name: 'installment',
      label: 'Nº de Parcelas',
      defaultValue: '1',
      options: [
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
        { label: '6', value: 6 },
        { label: '7', value: 7 },
        { label: '8', value: 8 },
        { label: '9', value: 9 },
        { label: '10', value: 10 },
        { label: '11', value: 11 },
        { label: '12', value: 12 },
      ],
      callback,
    },
    installment_value: {
      model: 'currencyInput',
      name: 'installment_value',
      label: 'Valor da parcela',
      defaultValue: '0',
      readOnly: true,
    },




    courses: {
      model: 'JsonInput',
      endpoint: `/courses`,
      name: 'courses',
      label: 'Cursos',
    },
  };

  const config: ISearchComponent = {
    idKey: `${endpoint}-${projectHash}-${eventHash}`,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [
      () =>
        lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),

      () => sendAllPayments(),
      () => exportGlobalData(),
  () => ReprocessInvoices(),
    () => SendInvoiceTestMail() 
    ],
    bodyModules: user.email === 'guilherme@encontrodigital.com.br' ?
      [
        (lineData: Record<string, any>) =>
          lineModules.updateUnique({
            lineData,
            title,
            formSchema,
            validationSchema: {},
            endpoint,
          }),



        (lineData: Record<string, any>) =>
          lineModules.delete({
            lineData,
            title,
            formSchema,
            validationSchema: formValidation,
            endpoint,
          }),

        (lineData: Record<string, any>) => sendPayment({ lineData }),
        (lineData: Record<string, any>) => visualizarBoleto({ lineData }),
        (lineData: Record<string, any>) => contact({ lineData }),
        (lineData: Record<string, any>) =>  DuplicatePayment({lineData}),
         (lineData: Record<string, any>) =>  DuplicatePaymentReference({lineData}),
(lineData: Record<string, any>) =>  SendInvoiceMail({lineData})
      ] : [
        (lineData: Record<string, any>) =>
          lineModules.updateUnique({
            lineData,
            title,
            formSchema,
            validationSchema: {},
            endpoint,
          }),
        (lineData: Record<string, any>) =>
          lineModules.delete({
            lineData,
            title,
            formSchema,
            validationSchema: formValidation,
            endpoint,
          }),

        (lineData: Record<string, any>) => sendPayment({ lineData }),
        (lineData: Record<string, any>) => visualizarBoleto({ lineData }),
        (lineData: Record<string, any>) => contact({ lineData }),
         (lineData: Record<string, any>) =>  DuplicatePayment({lineData}),
              (lineData: Record<string, any>) =>  DuplicatePaymentReference({lineData}),

(lineData: Record<string, any>) =>  SendInvoiceMail({lineData})


      ],
  };

  return (
    <Container>

      <SearchComponent {...config} />
    </Container>
  );
};

export default Sale;
